import {createAction, props} from '@ngrx/store';
import {ProleisObject} from 'proleis-rest-client';

export const scanObject = createAction(
  '[Scanner] scan object',
  props<{ scanCode: string }>(),
);

export const onScanObjectSuccess = createAction(
  '[Scanner] scan object success',
  props<{ object: ProleisObject }>(),
);

export const onScanSequenceSuccess = createAction(
  '[Scanner] scan sequence executed',
  props<{ result: string }>(),
);

export const onScanError = createAction(
  '[Scanner] error',
  props<{ error: string }>(),
);

export const relocate = createAction(
  '[Logistics] logistics relocation',
  props<{
    sourceId: string;
    targetId: string;
  }>(),
);

export const onRelocateSuccess = createAction(
  '[Logistics] relocation successful',
);

export const updateLogistics = createAction(
  '[Logistics] update logistics',
  props<{
    posIds: string[];
    storageId: string;
  }>(),
);

export const onUpdateLogisticsSuccess = createAction(
  '[Logistics] update logistics success',
);

export const createTransport = createAction(
  '[Logistics] create transport',
  props<{
    posId: string;
    storageId: string;
  }>(),
);

export const onCreateTransportSuccess = createAction(
  '[Logistics] create transport success',
);
